import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { MdCheckCircle } from 'react-icons/md';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';

export type SMBWhyTrustNerdWalletBulletProps = StructuredContentDocument<{
  children: StructuredContentDocument;
  rendererProps?: RendererProps;
}>;

export function SMBWhyTrustNerdWalletBullet({
  props: { children, rendererProps },
}: SMBWhyTrustNerdWalletBulletProps) {
  return (
    <div
      className={css({
        display: 'flex',
        '& div': {
          marginBottom: '[0 !important]',
        },
      })}
    >
      <span
        className={css({
          color: 'green.main',
          marginRight: '1',
          fontSize: 'xl',
          lineHeight: 'normal',
        })}
        aria-hidden="true"
      >
        <MdCheckCircle />
      </span>
      {renderStructuredContent(children, rendererProps)}
    </div>
  );
}
